import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Grid,
  OutlinedInput,
  InputLabel,
  IconButton,
  InputAdornment,
  Typography,
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { POPUP_DURATION_DELAY, usePopup } from '../context/PopupContext';

import { CustomFormControl } from './StyledInputs';
import { DefaultContainedButton, DefaultOutlinedButton } from './Buttons';
import API from '../api';
import { HttpErrorHandler } from './ErrorHandler';

export const ResetPasswordDialog = ({ openDialog, closeDialog }) => {
  const userInfo = JSON.parse(localStorage.getItem('userData'));
  const { showPopup, setPopUpText } = usePopup();

  // user reset password handler
  const [showOldPassword, setShowOldPassword] = useState({});
  const [showNewPassword, setShowNewPassword] = useState({});
  const [showRepeatPassword, setShowRepeatPassword] = useState({});
  const handleClickShowOldPassword = () => setShowOldPassword((show) => !show);
  const handleClickShowNewPassword = () => setShowNewPassword((show) => !show);
  const handleClickShowRepeatPassword = () => setShowRepeatPassword((show) => !show);

  // Reset user password request
  const onResetPassword = (event) => {
    event.preventDefault();

    const data = new FormData(event.currentTarget);
    const repeatNewPassword = data.get('repeatPassword');
    const resetPassword = {
      old_password: data.get('oldPassword'),
      new_password: data.get('newPassword'),
      first_login_done: 0,
    };
    let itemsLeft = false;

    Object.keys(resetPassword).forEach((key) => {
      const value = resetPassword[key];

      if (Object.prototype.hasOwnProperty.call(resetPassword, key)) {
        if (value === undefined || value === null || (typeof value === 'string' && value.length === 0)) {
          itemsLeft = true;
          showPopup('warning', 'Inserisci i dati mancanti');
        }
      }
    });

    if (!itemsLeft) {
      if (
        resetPassword.new_password === repeatNewPassword &&
        resetPassword.new_password !== resetPassword.old_password
      ) {
        const isMaiuscValid = /^(?=.*[A-Z])/.test(resetPassword.new_password);
        const isNumberValid = /(?=.*\d)/.test(resetPassword.new_password);
        const isSpecialValid = /(?=.*[!?@#$%^&*()_+-])/.test(resetPassword.new_password);

        if (isMaiuscValid) {
          if (isNumberValid) {
            if (isSpecialValid) {
              API.patch(`/users/${userInfo.id}/password`, resetPassword)
                .then((response) => {
                  const _lgData = JSON.parse(localStorage.getItem('loginData'));
                  _lgData.password = resetPassword.new_password;
                  localStorage.setItem('loginData', JSON.stringify(_lgData));

                  showPopup(true, 'Password modificata con successo');
                  setTimeout(() => {
                    closeDialog();
                  }, POPUP_DURATION_DELAY);
                })
                .catch((error) => {
                  if (error.response.status === 422) {
                    HttpErrorHandler(error, setPopUpText);
                    showPopup(false);
                  }
                });
            } else {
              showPopup(false, 'La password deve contenere almeno un carattere speciale');
            }
          } else {
            showPopup(false, 'La password deve contenere almeno un numero');
          }
        } else {
          showPopup(false, 'La password deve contenere almeno una lettera maiuscola');
        }
      } else if (
        resetPassword.new_password === repeatNewPassword &&
        resetPassword.new_password === resetPassword.old_password
      ) {
        showPopup(false, 'La nuova password deve essere diversa da quella precedente');
      } else if (
        resetPassword.new_password !== repeatNewPassword &&
        resetPassword.new_password !== resetPassword.old_password
      ) {
        showPopup(false, 'Le password inserite devono essere uguali');
      } else {
        showPopup(false, 'Dati inseriti non validi');
      }
    }
  };


  return (
    <Dialog fullWidth open={openDialog} onClose={() => {}}>
      <form onSubmit={onResetPassword}>
        <DialogTitle sx={{ textAlign: 'center' }}>Modifica Password</DialogTitle>
        <DialogContentText sx={{ padding: '0 24px' }}>
          <Grid container>
            <Grid item xs={12}>
              <Typography>La password deve contenere almeno:</Typography>
              <Typography>&#x2022; 8 caratteri</Typography>
              <Typography>&#x2022; Una lettera maiuscola</Typography>
              <Typography>&#x2022; Un numero</Typography>
              <Typography>&#x2022; Uno dei seguenti caratteri speciali !?-@#$%^&*()_+</Typography>
            </Grid>
          </Grid>
        </DialogContentText>

        <DialogContent>
          <Grid container spacing={3}>
            {/* Old Password */}
            <Grid item xs={12}>
              <CustomFormControl fullWidth>
                <InputLabel htmlFor="outlined-old-password">Vecchia Password</InputLabel>
                <OutlinedInput
                  required
                  id="outlined-old-password"
                  type={showOldPassword ? 'password' : 'text'}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowOldPassword}
                        onMouseDown={(e) => e.preventDefault()}
                        onMouseUp={(e) => e.preventDefault()}
                        edge="end"
                      >
                        {showOldPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Vecchia Password"
                  name="oldPassword"
                />
              </CustomFormControl>
            </Grid>

            {/* New Password */}
            <Grid item xs={12}>
              <CustomFormControl fullWidth>
                <InputLabel htmlFor="outlined-new-password">Nuova Password</InputLabel>
                <OutlinedInput
                  required
                  id="outlined-new-password"
                  type={showNewPassword ? 'password' : 'text'}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowNewPassword}
                        onMouseDown={(e) => e.preventDefault()}
                        onMouseUp={(e) => e.preventDefault()}
                        edge="end"
                      >
                        {showNewPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                  label="NuovaPassword"
                  name="newPassword"
                />
              </CustomFormControl>
            </Grid>

            {/* Repeat New Password */}
            <Grid item xs={12}>
              <CustomFormControl fullWidth>
                <InputLabel htmlFor="outlined-repeat-password">Ripeti Nuova Password</InputLabel>
                <OutlinedInput
                  required
                  id="outlined-repeat-password"
                  type={showRepeatPassword ? 'password' : 'text'}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowRepeatPassword}
                        onMouseDown={(e) => e.preventDefault()}
                        onMouseUp={(e) => e.preventDefault()}
                        edge="end"
                      >
                        {showRepeatPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Ripeti Nuova Password"
                  name="repeatPassword"
                />
              </CustomFormControl>
            </Grid>
          </Grid>

        </DialogContent>
        <DialogActions sx={{ paddingRight: 3, paddingBottom: 3 }}>
          <DefaultOutlinedButton onClick={closeDialog}>Chiudi</DefaultOutlinedButton>
          <DefaultContainedButton type="submit">Salva</DefaultContainedButton>

        </DialogActions>
      </form>
    </Dialog>
  );
};
